import MAYA from '../../../maya_api'
import {getRandomString, DFS} from "../../../helpers";
import _ from 'lodash';

export function changePhoneNumber(value){
  return function (state) {
    return {phone_number: DFS(value), error: null}
  }
}

export function changePassword(value){
  return function (state) {
    return {password: value, error: null}
  }
}

export function changeAccount(value) {
  return function (state) {
    return {phone_number: value, error: null}
  }
}

export function setLoading(value){
  return function (state) {
    return {loading: value}
  }
}

export function setDevices(value){
  return function (state) {
    return {devices: value, loading: false}
  }
}

export function setSelectedDevice(value){
  return function (state) {
    return {selectedDevice: value}
  }
}

export function resetDevices() {
  return function (state) {
    return {selectedDevice: '', devices: []}
  }
}

export function setError(type, title, message) {
  return function (state) {
    return {error: {[type]: true, header: title, content: message}, loading: false}
  }
}

export function switchAccountMode() {
  return function (state) {
    const newState = !state.showNewClerk;
    let phoneNumber = '';

    if(!newState) phoneNumber = MAYA.getPhoneNumber();

    return {showNewClerk: newState, phone_number: phoneNumber, error: null}
  }
}

export async function tryToInitDevice(phone_number, password, device_guid) {
  const authToken = getRandomString(32);

  const result = await MAYA.initDevice(phone_number, password, authToken, device_guid);

  console.log('Sign in result =>', result);

  if(result && result.otc_token){

    let username = `+${phone_number}${result.username ? ` (${result.username.trim()})` : ''}`;

    let accounts = MAYA.getAccounts();

    if(accounts && accounts.length){
      _.each(accounts, function(item) {
        if(phone_number === item.value){
          return item.text = username;
        }
      });

      accounts = _.unionBy(accounts, [{value: phone_number, text: username}], 'value')
    } else {
      accounts = [{value: phone_number, text: username}]
    }

    localStorage.setItem('otc_token', result.otc_token);
    localStorage.setItem('auth_token', authToken);
    localStorage.setItem('accounts', JSON.stringify(accounts));

    MAYA.updateDeviceSocket(result.otc_token);
  }

  return result;
}



// WEBPACK FOOTER //
// ./src/routes/Login/services/login.js